var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgElectricVehicles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Clean-Car-Leaf-2--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Clean Car Leaf 2 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.71 6.19c2.33 -1.5 6 -3.13 8.65 -2.54a0.61 0.61 0 0 1 0.46 0.72 0.59 0.59 0 0 1 -0.72 0.46 8.57 8.57 0 0 0 -4.59 0.75 0.51 0.51 0 0 0 -0.3 0.61c0.49 1.65 2.29 2.19 4 2 2.09 -0.28 5.34 -3 6 -5.6a0.58 0.58 0 0 0 -0.1 -0.51 0.57 0.57 0 0 0 -0.46 -0.24A8 8 0 0 1 15.43 0.9a8.28 8.28 0 0 0 -2.81 -0.9 3.31 3.31 0 0 0 -2.94 1 2.64 2.64 0 0 0 -0.57 1.74 0.47 0.47 0 0 1 -0.32 0.47A21.11 21.11 0 0 0 5 5.19a0.62 0.62 0 0 0 -0.13 0.81 0.61 0.61 0 0 0 0.84 0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.86 14a1 1 0 0 0 -1.37 -0.35L19 14a0.51 0.51 0 0 1 -0.76 -0.37l-0.12 -1.06a2 2 0 0 0 -2 -1.77H7.89a2 2 0 0 0 -2 1.77l-0.12 1.06A0.51 0.51 0 0 1 5 14l-0.51 -0.31a1 1 0 1 0 -1 1.72l0.81 0.49a0.47 0.47 0 0 1 0.23 0.32 0.49 0.49 0 0 1 -0.08 0.39A2.56 2.56 0 0 0 4 18v1a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 19v-1a2.56 2.56 0 0 0 -0.45 -1.44 0.49 0.49 0 0 1 -0.08 -0.39 0.47 0.47 0 0 1 0.23 -0.32l0.81 -0.49a1 1 0 0 0 0.35 -1.36Zm-4.61 1.34a0.52 0.52 0 0 1 -0.38 0.17H8.13a0.52 0.52 0 0 1 -0.38 -0.17 0.5 0.5 0 0 1 -0.12 -0.39l0.21 -1.75a0.5 0.5 0 0 1 0.49 -0.44h7.34a0.5 0.5 0 0 1 0.49 0.44l0.21 1.75a0.5 0.5 0 0 1 -0.12 0.38Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21.5h-2a0.5 0.5 0 0 0 -0.5 0.5v0.5a1.5 1.5 0 0 0 3 0V22a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 21.5h-2a0.5 0.5 0 0 0 -0.5 0.5v0.5a1.5 1.5 0 0 0 3 0V22a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgElectricVehicles);
export default ForwardRef;